export const VendorGroupStatus = Object.freeze({
    active: 'active',
    submitted: 'submitted',
    disabled: 'disabled',
    deleted: 'deleted',
});
